export default function eventEmitter() {
    const _topics = {};

    return {
        emit(topic, data) {
            if (!_topics[topic]) {
                return;
            }

            _topics[topic].forEach(callback => callback(data));
        },
        on(topic, callback) {
            if (!_topics[topic]) {
                _topics[topic] = [];
            }

            _topics[topic].push(callback);
        }
    };
}
